import { Observable } from 'rxjs';
import { EnablingCodeModel } from '../../models/configuration/enabling-code.model';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { UseCase } from '../../base/use-case';

export class GetEnablingsCodeUseCase
  implements UseCase<void, EnablingCodeModel>
{
  constructor(private configRepository: ConfigurationRepository) {}
  execute(): Observable<EnablingCodeModel> {
    return this.configRepository.getEnablingsCode();
  }
}
